"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionService = void 0;
const typedi_1 = require("typedi");
const axios_1 = __importDefault(require("axios"));
const axios_jsonp_1 = __importDefault(require("axios-jsonp"));
/**
 * Сервис подписок
 */
let SubscriptionService = class SubscriptionService {
    constructor() {
        this.index = 0;
    }
    /**
     * Подписывает пользователя
     */
    subscribe(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            window[`subscriptionCallback${this.index}`] = (data) => {
                if (data.result === 'error') {
                    reject({
                        errors: { email: data.msg || 'Something went wrong' },
                    });
                }
                resolve();
            };
            try {
                yield (0, axios_1.default)({
                    url: 'https://art.us14.list-manage.com/subscribe/post-json',
                    params: Object.assign(Object.assign({ u: '9dbae96f0551883c042f5ac0f', id: '3939e22924' }, params), { c: `subscriptionCallback${this.index}` }),
                    adapter: axios_jsonp_1.default,
                    responseType: 'json',
                });
            }
            catch (err) {
                reject({
                    'error': 'Could not connect to the registration server. Please try again later.',
                });
            }
        }));
    }
};
SubscriptionService = __decorate([
    (0, typedi_1.Service)()
], SubscriptionService);
exports.SubscriptionService = SubscriptionService;
